export default "__VITE_ASSET__C4vKt98u__"